var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list",
    { staticClass: "solis-menu pa-2", attrs: { dense: "" } },
    [
      _vm._l(_vm.nodes, function(page, i) {
        return [
          page.children.length === 0
            ? _c(
                "v-list-item",
                {
                  key: i,
                  staticClass: "solis-menu__item",
                  attrs: {
                    to: page.to,
                    "active-class": "solis-menu__item--active"
                  }
                },
                [
                  _c(
                    "v-list-item-icon",
                    { staticClass: "mr-3" },
                    [
                      _c("v-icon", { attrs: { size: "20" } }, [
                        _vm._v(_vm._s(page.icon))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [_c("v-list-item-title", [_vm._v(_vm._s(page.name))])],
                    1
                  )
                ],
                1
              )
            : _c(
                "v-list-group",
                {
                  key: "g-" + i,
                  staticClass: "solis-menu__group",
                  attrs: {
                    "active-class": "solis-menu__group--active",
                    "prepend-icon": page.icon
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function() {
                          return [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v(_vm._s(page.name))
                                ])
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _vm._v(" "),
                  _vm._l(page.children, function(childPage, j) {
                    return _c(
                      "v-list-item",
                      {
                        key: j,
                        staticClass: "solis-menu__child",
                        attrs: {
                          to: childPage.to,
                          "active-class": "solis-menu__item--active"
                        }
                      },
                      [
                        _c(
                          "v-list-item-icon",
                          { staticClass: "mr-3" },
                          [
                            _c("v-icon", { attrs: { size: "16" } }, [
                              _vm._v(_vm._s(childPage.icon))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-item-content",
                          [
                            _c("v-list-item-title", [
                              _vm._v(_vm._s(childPage.name))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1435b674", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1435b674","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menubar.vue
// module id = null
// module chunks = 